import React from "react";
import Home_Banner from "./Home_Banner/Home_Banner";
import Game_play_slider from "./Game_play_slider/Game_play_slider";
import What_WinGo_Offers from "./What_WinGo_Offers/What_WinGo_Offers";
import Website_ugread from "../Common/Common_Component/Website_ugread/Website_ugread";

function Home() {
  return (
    <>
      <section className="container">
        <Home_Banner />
        <Website_ugread />
        <Game_play_slider />
        <What_WinGo_Offers />
      </section>
    </>
  );
}

export default Home;
